import { CheckOutlined } from "@ant-design/icons";
import classNames from "classnames";
import React, { useLayoutEffect, useRef, useState } from "react";
import { FlexibleSelectData } from "./type";
import { Popover } from "antd";

interface OptionProps {
    isActive: boolean;
    data: FlexibleSelectData;
    onCheck?: (data: FlexibleSelectData, checked: boolean, index: number) => void;
    index: number;
    optionHeight: number;
}

const Option: React.FC<OptionProps> = function (props) {
    const { isActive, data, onCheck, index, optionHeight } = props;
    const { value, label } = data;
    const element = useRef<HTMLLIElement>();
    const [overflow, setOverflow] = useState(false);

    function handleCheck() {
        onCheck(data, !isActive, index);
    }

    useLayoutEffect(() => {
        setOverflow(element.current?.scrollWidth > element.current?.clientWidth);
    }, []);

    return (
        <li
            ref={element}
            value={value}
            className={classNames("option", isActive && "option-active")}
            onClick={handleCheck}
            style={{ height: optionHeight }}
        >
            {isActive && <CheckOutlined className="mr5 success" />}
            {overflow ? (
                <Popover content={label} placement="left" mouseEnterDelay={0.5}>
                    <span>{label}</span>
                </Popover>
            ) : (
                label
            )}
        </li>
    );
};

export default React.memo(Option);
